import React from 'react';
import { Flex, Input, Form, Upload, AutoComplete, List,
    Select, Image, Button, Radio, InputNumber, Divider, Cascader, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import {getCurrentShopId} from '../shop/get-current-shop';
import fetch from '../../utils/fetch';
import SelectShop from '../shop/select-shop';
import SysCategorySelect from '../category/sys-category-select';
import ShopCategorySelect from '../category/shop-category-select';
import Properties from '../../components/properties';
import PartnerPercentSetting from '../level/partner-percent-setting';
import SharePercentSetting from '../level/share-percent-setting';
import SKU from './skus';
import SortableUpload from '../../components/sortable-upload';

export default (props) => {
    const accId = window.__baseInfo.accId;
    const MAIN_IMG_MAX = 6;
    const DETAIL_IMG_MAX = 8;
    const imageUrlPrefix = '//img.yxdj.tech/';
    const [currentShopId, setCurrentShopId] = React.useState(null);
    const params = new URLSearchParams(window.location.search);
    const goodsId = params.get('goodsId');
    const action = params.get('action');
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setCurrentShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    const formTitle = () => {
        switch (action) {
            case 'copy':
                return '复制并创建商品';
            case 'view':
                return '查看商品';
            case 'edit':
                return '编辑商品';
            default:
                return '创建商品';
        }
    }
    // const message = App.useApp();
    // const message = Message.useMessage();

    const [loading, setLoading] = React.useState(false);
    const [form] = Form.useForm();
    const multiSku = Form.useWatch('multiSku', form);
    const unit = Form.useWatch('unit', form);
    const goodsType = Form.useWatch('type', form);
    // const [shops, setShops] = React.useState([]);
    const [cates, setCates] = React.useState([]);
    const [units, setUnits] = React.useState([]);
    const [imageUrl, setImageUrl] = React.useState();
    const [properties, setProperties] = React.useState([{k: '', v: ''}]);
    const [partnerLevelPercents, setPartnerLevelPercents] = React.useState([]);
    const [shareLevelPercents, setShareLevelPercents] = React.useState([]);

    // const shops = Form.useWatch('shops', form);
    const [mainImages, setMainImages] = React.useState([]);;
    const [detailImages, setDetailImages] = React.useState([]);

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传图片</div>
        </button>
    );

    React.useEffect(() => {
        initForm();
        getUnits();
    }, []);

    const beforeUpload = async (file) => {
        // console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
        if (!isJpgOrPng) {
            message.error('请上传JPG/PNG图片!');
        }
        const isLt8M = file.size / 1024 / 1024 < 8;
        if (!isLt8M) {
            message.error('图片必须小于 8MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt8M;
    };

    const getUnits = async () => {
        let response = await fetch(`/api/shop/unit`);
        let result = await response.json();
        if(result && result.success) {
            let units = result.data.map(item => {
                return {
                    value: item.name,
                    // label: item,
                }
            }
            );
            setUnits(units);
        }
    }

    const handleChange = (fieldName, {file, fileList}) => {
        // console.log(file.status, fieldName, file, fileList);

        // if(file.status === undefined) return false;

        if(file.status === 'done') {
            let thumbUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com', 'https://img.yxdj.tech');
            let imgUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com/', '');

            fileList = fileList.map((item) => {

                if(file.uid === item.uid) {
                    return { uid: item.uid, type: item.type, thumbUrl: thumbUrl + '?x-oss-process=image/resize,w_200', url: imgUrl }
                } else {
                    return item
                }
            });
        }

        // if(file.status === 'done') console.log('done', fileList);

        if(fieldName === 'mainImages') {
            setMainImages([
                ...fileList,
            ]);
        }else if(fieldName === 'detailImages') {
            setDetailImages([
                ...fileList,
            ]);
        }

        if (file.status === 'done') {
            setLoading(false);
        }else{
            if(loading === false) setLoading(true);
        }
    };

    const initForm = () => {

        if(goodsId) {
            getGoodsDetail(goodsId).then(result => {
                // result.shops = result.shopId_shops;
                // console.log('result.mainImages', result.mainImages);
                if(result.mainImages) setMainImages( result.mainImages.map(item => ({url: item, thumbUrl: `${imageUrlPrefix}${item}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"})) );
                if(result.detailImages) setDetailImages( result.detailImages.map(item => ({url: item, thumbUrl: `${imageUrlPrefix}${item}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"})) );
                if(result.properties) setProperties(result.properties);

                // delete result.mainImages;
                // delete result.detailImages;

                // 处理代理商佣金初始化数据
                if(result.goods_partner_level_percents) {
                    setPartnerLevelPercents(result.goods_partner_level_percents);
                }

                // 处理分享佣金初始化数据
                if(result.goods_share_level_percents) {
                    setShareLevelPercents(result.goods_share_level_percents);
                }

                // SKU 处理
                if(result.multiSku) {
                    result.skus = {
                        name: result.skuTitle,
                        options: [...result.goods_skus.map(item => ({...item, price: item.price / 100, marketPrice: item.marketPrice / 100}))]
                    } 
                }

                form.setFieldsValue({
                    ...result,
                    shops: result.shopId_shops,
                    price: result.price/100,
                    marketPrice: result.marketPrice/100,
                    prepaidAmount: result.prepaidAmount == null ? '' : result.prepaidAmount/100,
                })
            });
        }else{
            form.setFieldsValue({
                displayInShop: 1,
                allowOtherSell: 1,
            });
        }
    }

    const getGoodsDetail = async (goodsId) => {
        let response = await fetch(`/api/goods/detail?goodsId=${goodsId}&accId=${accId}`);
        let result = await response.json();

        if(result && result.success) {
            return result.data;
        }

        return null;
    }

    const onSubmitForm = async () => {
        const values = await form.validateFields();
        if(values.multiSku) {
            const checkOptions = values?.skus?.options?.every(item => item.price && item.price > 0 && item.marketPrice && item.marketPrice > 0 && item.title);
            if(!checkOptions) {
                message.error('请填写完整售卖规格');
                return;
            }
        }

        if(values.sysCateId instanceof Array && values.sysCateId.length > 0) {
            values.sysCateId = values.sysCateId[values.sysCateId.length - 1];
        }
        // 用于商品归属店铺
        values.ownerShopId = currentShopId;
        // 代理商佣金处理
        if(values.partnerLevelPercent) {
            values.partnerLevelPercent = values.partnerLevelPercent.filter(({percent}) => (percent && percent >= 0));
        }

        // 处理分享佣金
        if(values.shareLevelPercent) {
            values.shareLevelPercent = values.shareLevelPercent.filter(({percent}) => (percent && percent >= 0));
        }

        // 商品主图
        if(mainImages){
            let images = [];

            mainImages.forEach(item => {
                // let url = item?.thumbUrl?.replace(/.*?\/\/.*?\//, '');

                images.push(item.url);
            });

            values.mainImages = images;
        }
        // 商品详情图
        if(detailImages){
            let images = [];

            detailImages.forEach(item => {
                // let url = item?.thumbUrl?.replace(/.*?\/\/.*?\//, '');

                images.push(item.url);
            });

            values.detailImages = images;
        }

        values.status = 1;

        if(values){
            Object.keys(values).forEach(key => {
                if(values[key] === undefined) {
                    delete values[key];
                }
            });
        }

        // console.log(values);
        // return;
        let url = '';
        
        if(goodsId && action === 'copy') {
            url = `/api/goods/create`;
        } else if(action === 'edit') {
            url = `/api/goods/edit?goodsId=${goodsId}`;
        } else {
            url = `/api/goods/create`;
        }

        let response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(values),
        });
        let result = await response.json();

        if (result && result.success) {
            message.success('提交成功');
            setTimeout(() => {
                window.location.href = '/goods';
            }, 800);
        } else {
            message.error(result.data || '提交失败');
        }
    }

    return (
        <div>
            <SwitchShop />
            
            <div className="text-center mb-2 text-xs text-gray-500">
              当前版本: {({1:'基础版',2:'专业版',3:'连锁版'})[window.__baseInfo.versionId] || ''}
              | 商品上限: {({1:10,2:1000,3:100000})[window.__baseInfo.versionId] || ''} 个
            </div>
            <h2 className="admin-page-title text-center">{formTitle()}</h2>

            <div className="admin-form-container">
                <Form
                    form={form}
                    layout="vertical"
                    disabled={action === 'view' ? true : false}
                >
                    {/* <Divider>基础信息</Divider> */}

                    <Form.Item
                        label="商品类型"
                        name="type"
                        rules={[
                            {
                                required: true,
                                message: '请选择商品类型',
                            },
                        ]}
                    >
                        <Radio.Group 
                            // optionType='button'
                            onChange={() => form.setFieldsValue({sysCateId: undefined})}
                            options={[
                                {
                                    label: '服务',
                                    value: 'NORMAL',
                                },
                                {
                                    label: '实物',
                                    value: 'GOODS',
                                },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item
                        label="系统类目"
                        name="sysCateId"
                        rules={[
                            {
                                required: true,
                                message: '请选择类目',
                            },
                        ]}
                    >
                        {/* <Cascader options={cates} changeOnSelect /> */}
                        <SysCategorySelect defaultValue={form.getFieldValue('sysCateId')} goodsType={goodsType} />
                    </Form.Item>

                    <Form.Item
                        label="适用店铺"
                        name="shops"
                        rules={[{ required: true, message: '请选择店铺' }]}
                    >
                        <SelectShop />
                    </Form.Item>

                    <Form.Item
                        label="店铺分类"
                        name="cateId"
                        rules={[
                            {
                                required: true,
                                message: '请选择分类',
                            },
                        ]}
                    >
                        {/* <Cascader options={cates} changeOnSelect /> */}
                        <ShopCategorySelect />
                    </Form.Item>

                    <Form.Item
                        label="商品标题"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: '请输入商品标题',
                            },
                        ]}
                    >
                        <Input placeholder="请输入商品标题" count={{max: 30, show: true}} />
                    </Form.Item>

                    <Form.Item
                        label="商品简短描述"
                        name="shortDescription"
                    >
                        <Input.TextArea placeholder="请输入商品描述" count={{max: 120, show: true}} />
                    </Form.Item>
                    
                    <Form.Item
                        label="商品主图"
                        name="mainImages"
                        rules={[{ required: true, message: '请上传商品主图' }]}
                    >
                        <SortableUpload
                            // name="avatar"
                            // defaultFileList={mainImages}
                            fileList={mainImages}
                            listType="picture-card"
                            className="avatar-uploader"
                            maxCount={MAIN_IMG_MAX}
                            action="/api/upload/image"
                            beforeUpload={beforeUpload}
                            onChange={(file) => handleChange('mainImages', file)}
                            // showUploadList={false}
                            // itemRender={(originNode, file) => <SortableContainer.Item>{originNode}</SortableContainer.Item>}
                        >
                            {
                                mainImages.length >= MAIN_IMG_MAX ? null : uploadButton
                                // imageUrl 
                                // ? <img src={imageUrl + '?x-oss-process=image/resize,w_200'} alt="avatar" style={{ width: '100%' }} /> 
                                // : (mainImages.length >= MAIN_IMG_MAX ? null : uploadButton)
                            }
                        </SortableUpload>
                    </Form.Item>

                    <Flex gap={10}>
                        <Form.Item
                            label="商品编码"
                            name="code"
                        >
                            <Input placeholder="请输入商品编码" />
                        </Form.Item>
                    </Flex>

                    {goodsType === 'NORMAL' && <Form.Item
                        label="到家次数"
                        name="times"
                        help="指此服务需要上门服务的次数"
                        rules={[
                            {
                                required: true,
                                message: '请输入到家次数',
                            },
                        ]}
                    >
                        <Radio.Group>
                            <Radio value={1}>一次</Radio>
                            <Radio value={2}>两次</Radio>
                        </Radio.Group>
                    </Form.Item>}

                    <Form.Item
                        label="多规格售卖"
                        name="multiSku"
                        rules={[
                            {
                                required: true,
                                message: '请选择是否为多规格售卖',
                            },
                        ]}
                        initialValue={false}
                    >
                        <Radio.Group>
                            <Radio value={false}>单规格</Radio>
                            <Radio value={true}>多规格</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {multiSku && <Form.Item
                        label="售卖规格"
                        name="skus"
                        rules={[
                            {
                                required: true,
                                message: '请填写商品规格',
                            },
                        ]}
                        // initialValue={[]}
                    >
                        <SKU />
                    </Form.Item>}

                    <Form.Item
                        label="销售单位"
                        name="unit"
                        rules={[
                            {
                                required: true,
                                message: '请输入销售单位',
                            },
                        ]}
                    >
                        <AutoComplete options={units} style={{width: '6em'}} />
                    </Form.Item>

                    {!multiSku && <Flex gap={10} align='end'>
                        <Form.Item
                            label="实际售价"
                            name="price"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入实际售价',
                                },
                            ]}
                        >
                            <InputNumber addonAfter={'元'} precision={2} />
                        </Form.Item>

                        <Form.Item
                            label="市场价"
                            name="marketPrice"
                        >
                            <InputNumber addonAfter={'元'} precision={2} />
                        </Form.Item>
                    </Flex>}

                    <Form.Item
                        label="最小购买数量"
                        name="minNum"
                    >
                        <InputNumber style={{width: '178px'}} step={1} addonAfter={unit || ''} precision={0} placeholder="最小购买数量" />
                    </Form.Item>

                    <Flex gap={10}>
                        {goodsType === 'NORMAL' && <Form.Item
                            label="预付定金"
                            name="prepaidAmount"
                        >
                            <InputNumber addonAfter='元' precision={0} />
                        </Form.Item>}

                        <Form.Item
                            label="线下销量"
                            name="offlineSaleNum"
                        >
                            <InputNumber precision={0} addonAfter={unit || ''} />
                        </Form.Item>

                    </Flex>

                    <Form.Item label="商品属性" name='properties'>
                        <Properties defaultProperties={properties} />
                    </Form.Item>

                    <Form.Item
                        label="商品详情图"
                        name="detailImages"
                        // rules={[{ required: true, message: '请输入店铺名称' }]}
                    >
                        <SortableUpload
                            // name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            fileList={detailImages}
                            maxCount={8}
                            action="/api/upload/image"
                            beforeUpload={beforeUpload}
                            onChange={(file) => handleChange('detailImages', file)}
                        >
                            { (detailImages.length >= DETAIL_IMG_MAX ? null : uploadButton) }
                        </SortableUpload>
                    </Form.Item>

                    <Form.Item
                        label="商品详细描述"
                        name="description"
                    >
                        <Input.TextArea placeholder="请输入商品描述" count={{max: 500, show: true}} />
                    </Form.Item>

                    {goodsType === 'GOODS' && <Form.Item
                        label="运费模版"
                        name="shippingTmpId"
                        rules={[
                            {
                                required: true,
                                message: '请选择运费模版',
                            },
                        ]}
                        initialValue={'1'}
                    >
                         <Radio.Group options={[
                            {label: '包邮', value: '1'},
                         ]} />
                    </Form.Item>}

                    <Form.Item
                        label="在小程序中展示"
                        name="displayInShop"
                    >
                        <Radio.Group>
                            <Radio value={1}>展示</Radio>
                            <Radio value={0}>不展示</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Divider>代理设置</Divider>
                    <div style={{color: '#666'}}>其他商家在他的店铺上架你的商品，销售后可获得分成。</div>
                    <Flex gap={10}>
                        <Form.Item
                            label="允许其他商家代销"
                            tooltip="允许其他商家上架到他的小程序，订单最终会流入你的店铺，其他商家获得佣金"
                            name="allowOtherSell"
                        >
                            <Radio.Group>
                                <Radio value={1}>允许</Radio>
                                <Radio value={0}>不允许</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Flex>
                    <Flex gap={10}>
                        <Form.Item
                            style={{ minWidth: '60px' }}
                            label="代理佣金比例"
                            name="partnerLevelPercent"
                            tooltip="代理佣金 = x% * 实际成交金额"
                        >
                            <PartnerPercentSetting accId={accId} goodsId={goodsId} defaultValue={partnerLevelPercents} />
                            {/* <div><a href='/salesnet'>设置代理商/等级</a></div> */}
                        </Form.Item>                    

                    </Flex>
                    <Divider>分享设置</Divider>
                    <div style={{color: '#666'}}>用户在小程序分享你的商品，销售后可获得佣金。</div>

                    <Flex gap={10}>
                        <Form.Item
                            style={{ minWidth: '60px' }}
                            label="用户分享佣金比例"
                            name="shareLevelPercent"
                            tooltip="分享佣金 = x% * 实际成交金额"
                        >
                            <SharePercentSetting accId={accId} goodsId={goodsId} defaultValue={shareLevelPercents} />
                            {/* <div><a href='/salesnet'>设置分销商/等级</a></div> */}
                        </Form.Item>
                    </Flex>
                </Form>
                
                <div className="admin-form-actions justify-center">
                    {
                        action !== 'view'
                            ? <>
                                <Button type='default' size='large' href='/goods'>取消</Button>
                                <Button type='primary' size='large' onClick={onSubmitForm}>提交</Button>
                              </>
                            : <Button type='default' size='large' href='/goods'>返回</Button>
                    }
                </div>
            </div>
        </div>
    )
}